import { render, staticRenderFns } from "./MaterialPrice.vue?vue&type=template&id=5664e93f"
import script from "./MaterialPrice.vue?vue&type=script&lang=js"
export * from "./MaterialPrice.vue?vue&type=script&lang=js"
import style0 from "./MaterialPrice.vue?vue&type=style&index=0&id=5664e93f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports